function checkIsMobile() {
	return window.innerWidth <= 768;
}
export default checkIsMobile;
